import React from 'react';
import { cn } from '../../utils/cn';
import type { IconProps } from './icons.types';

/**
 * GiftBox - Gift box icon component
 */
export const GiftBox: React.FC<IconProps> = ({ width = 27, height = 28, className }) => (
    <svg width={width} height={height} viewBox="0 0 27 28" fill="none" className={cn('inline-block', className)}>
        <defs>
            <clipPath id="clip0">
                <rect width="27" height="28" fill="white" />
            </clipPath>
        </defs>
        <g clipPath="url(#clip0)">
            <path
                d="M2.61035 11.4697H24.4789V25.3857C24.4789 25.729 24.4109 26.0689 24.2788 26.3861C24.1466 26.7033 23.953 26.9915 23.7088 27.2342C23.4647 27.477 23.1749 27.6695 22.8559 27.8009C22.5369 27.9323 22.195 27.9999 21.8498 27.9999H5.23946C4.54218 27.9999 3.87345 27.7245 3.3804 27.2342C2.88735 26.744 2.61035 26.079 2.61035 25.3857V11.4697Z"
                fill="#22409A"
            />
            <path
                d="M24.6291 6.75488H2.37089C1.06148 6.75488 0 7.81035 0 9.11234C0 10.4143 1.06148 11.4698 2.37089 11.4698H24.6291C25.9385 11.4698 27 10.4143 27 9.11234C27 7.81035 25.9385 6.75488 24.6291 6.75488Z"
                fill="#2AC4F3"
            />
            <path
                d="M8.07509 4.5467L8.04222 4.50936C7.54907 4.01155 7.27264 3.34083 7.27264 2.64207C7.27264 1.94331 7.54907 1.27259 8.04222 0.774779C8.28831 0.528623 8.58091 0.333275 8.9032 0.199974C9.22549 0.0666721 9.5711 -0.00195312 9.92016 -0.00195312C10.2692 -0.00195312 10.6148 0.0666721 10.9371 0.199974C11.2594 0.333275 11.552 0.528623 11.7981 0.774779L13.507 2.47401L15.2253 0.774779C15.4871 0.514238 15.8008 0.311189 16.1464 0.17875C16.492 0.0463116 16.8617 -0.0125704 17.2316 0.00590726C17.6015 0.0243849 17.9633 0.11981 18.2938 0.286021C18.6243 0.452232 18.9161 0.68553 19.1502 0.970844C19.5617 1.50334 19.7618 2.16774 19.7125 2.83749C19.6631 3.50724 19.3678 4.13554 18.8826 4.60272L13.5305 9.9525L8.07509 4.5467Z"
                fill="#FDCB34"
            />
            <path d="M15.6667 9.42041H11.3756V27.9999H15.6667V9.42041Z" fill="#FDCB34" />
        </g>
    </svg>
);

/**
 * BlueHeartIcon - Blue heart icon component
 */
export const BlueHeartIcon: React.FC<IconProps> = ({ width = 14, height = 11, className }) => (
    <svg width={width} height={height} viewBox="0 0 14 11" className={cn('inline-block', className)}>
        <rect x="0.5" width="13" height="11" fill="#2196F3" />
    </svg>
);

/**
 * TicketGrayIcon - Ticket gray icon component
 */
export const TicketGrayIcon: React.FC<IconProps> = ({ width = 24, height = 24, className }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" className={cn('inline-block', className)}>
        <path
            d="M20 8H4C2.89543 8 2 8.89543 2 10V10.5C2 11.3284 2.67157 12 3.5 12C4.32843 12 5 12.6716 5 13.5V13.5C5 14.3284 4.32843 15 3.5 15H3.5C2.67157 15 2 15.6716 2 16.5V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V16.5C22 15.6716 21.3284 15 20.5 15C19.6716 15 19 14.3284 19 13.5C19 12.6716 19.6716 12 20.5 12C21.3284 12 22 11.3284 22 10.5V10C22 8.89543 21.1046 8 20 8Z"
            fill="#9E9E9E"
        />
    </svg>
);

/**
 * TicketWithMarkedIcon - Ticket with mark icon component
 */
export const TicketWithMarkedIcon: React.FC<IconProps> = ({ width = 24, height = 24, className }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" className={cn('inline-block', className)}>
        <path
            d="M20 8H4C2.89543 8 2 8.89543 2 10V10.5C2 11.3284 2.67157 12 3.5 12C4.32843 12 5 12.6716 5 13.5V13.5C5 14.3284 4.32843 15 3.5 15H3.5C2.67157 15 2 15.6716 2 16.5V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V16.5C22 15.6716 21.3284 15 20.5 15C19.6716 15 19 14.3284 19 13.5C19 12.6716 19.6716 12 20.5 12C21.3284 12 22 11.3284 22 10.5V10C22 8.89543 21.1046 8 20 8Z"
            fill="#4CAF50"
        />
        <path d="M10 14L8 12L9 11L10 12L13 9L14 10L10 14Z" fill="white" />
    </svg>
);

/**
 * IconKidsNotice - Kids notice icon component
 */
export const IconKidsNotice: React.FC<IconProps> = ({ width = 24, height = 24, className }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" className={cn('inline-block', className)}>
        <circle cx="12" cy="12" r="10" fill="#FF9800" />
        <path d="M12 7V13" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="16" r="1" fill="white" />
    </svg>
);

/**
 * IconChevronRight - Chevron right icon component
 */
export const IconChevronRight: React.FC<IconProps> = ({
    width = 24,
    height = 24,
    color = 'currentColor',
    className,
}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" className={cn('inline-block', className)}>
        <path d="M9 6L15 12L9 18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/**
 * EmptyCartImage - Empty cart illustration component
 */
export const EmptyCartImage: React.FC<IconProps> = ({ width = 200, height = 200, className }) => (
    <svg width={width} height={height} viewBox="0 0 200 200" fill="none" className={cn('inline-block', className)}>
        <circle cx="100" cy="100" r="80" fill="#F5F5F5" />
        <path d="M60 70L70 120H130L140 70H60Z" stroke="#BDBDBD" strokeWidth="3" fill="none" />
        <circle cx="80" cy="135" r="5" fill="#BDBDBD" />
        <circle cx="120" cy="135" r="5" fill="#BDBDBD" />
        <path
            d="M85 90C85 90 90 95 100 95C110 95 115 90 115 90"
            stroke="#BDBDBD"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);

/**
 * GiftWithShaking - Gift with shaking animation component
 */
export const GiftWithShaking: React.FC<IconProps> = ({ width = 50, height = 50, className }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 50 50"
        fill="none"
        className={cn('inline-block animate-bounce', className)}
    >
        <rect x="10" y="15" width="30" height="25" fill="#FF6B6B" rx="2" />
        <rect x="10" y="10" width="30" height="8" fill="#FFD93D" rx="2" />
        <rect x="23" y="10" width="4" height="30" fill="#FFD93D" />
        <path
            d="M25 10C25 10 20 5 20 3C20 1 22 0 23 0C25 0 25 2 25 2C25 2 25 0 27 0C28 0 30 1 30 3C30 5 25 10 25 10Z"
            fill="#FF6B6B"
        />
    </svg>
);
